import Component from '@glimmer/component';
import { t } from 'ember-intl';
import ReimaginedContributionHistory from 'tio-employee/components/reimagined/production/contribution-history';
import type { ReimaginedContributionHistoryModel } from 'tio-employee/components/reimagined/production/contribution-history';
import type PersonModel from 'tio-common/models/person';

interface SlrDashboardSignature {
  Args: {
    model: { person: PersonModel; reimagined: ReimaginedContributionHistoryModel };
  };
}

export default class SlrDashboardRouteComponent extends Component<SlrDashboardSignature> {
  get reimaginedModel() {
    return this.args.model.reimagined;
  }

  <template>
    <div class="flex flex-col gap-2">
      <h1 class="px-4 pt-4 text-2xl font-semibold text-gray-900">{{t
          "dashboard_tiles.student_loan_repayment"
        }}</h1>
      <ReimaginedContributionHistory @model={{this.reimaginedModel}} />
    </div>
  </template>
}
